// NPM
import React from 'react'
import { Link } from 'gatsby'
import _ from 'lodash'

const Post = ({ post, isFeatured, linkText }) => {

  if(!post) {
    return null
  }

  return (
    <div className={ `Post ${ isFeatured ? "featured" : "" }` }>
      <div className="Post__image">
        <img src={ _.get(post, "heroImage.url") } />
      </div>

      <div className="Post__content">
        <h2 className="Post__title">
          { post.title }
        </h2>

        <p className="Post__shortContent">
          { post.shortContent }
        </p>

        <Link 
          className="Post__link"
          to={ `.${ post.path }` }>
            { linkText }
        </Link>
      </div>
    </div>
  )

}

export default Post